import { autoinject, transient } from "aurelia-dependency-injection";
import { DataType, SourceType } from "../../../../../../models/queries/queries.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";
import { BindingEngine } from "aurelia-binding";
import { I18N } from "aurelia-i18n";
import * as moment from "moment";

@autoinject()
@transient()
export class VesselPortActivitiesUploadHistoryDialog extends CustomGridPageBase {

    unPortCode: string;

    constructor(private dialogClientService: DialogClientService,
        i18N: I18N, itemsName: string = "Items",
        bindingEngine: BindingEngine) {
        super(i18N, itemsName, bindingEngine);
    }

    activate(model: { unPortCode: string }) {
        this.unPortCode = model.unPortCode;
        this.reload();
    }

    reload() {
        this.columns = [
            {
                dataType: DataType.Default,
                name: "fileName",
                title: "File Name",
                sortOrder: 1,
                columnOrder: -1,
                isHidden: false,
                isSortable: true
            },
            {
                dataType: DataType.Default,
                name: "status",
                title: "Status",
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true
            },
            {
                dataType: DataType.Default,
                name: "errorDetails",
                title: "Error Details",
                sortOrder: 3,
                columnOrder: -1,
                isHidden: false,
                isSortable: true
            },
            {
                dataType: DataType.Default,
                name: "createdBy",
                title: "Uploaded By",
                sortOrder: 4,
                columnOrder: -1,
                isHidden: false,
                isSortable: true
            },
            {
                dataType: DataType.DateTime,
                name: "createdOn",
                title: "Upload Date",
                sortOrder: 1,
                columnOrder: -1,
                isSortable: true,
                isAscending: false,
                valueConverter: x => x ? moment(new Date(x)).format("DD MMM YYYY HH:mm:ss") : null
            }];

        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: `odata/VesselPortActivityFileUploads/Genesis.GetVesselPortActivityFileUploads(unPortCode='${this.unPortCode}')`,
            columns: this.columns,
            initialFilters: [],
            initialSorting: this.initialSorting
        };
    }

    close() {
        this.dialogClientService.hide();
    }
}